import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names, letting a later Tailwind utility beat an earlier one.
 *
 * `clsx` alone keeps both `px-4` and `px-2` in the string and leaves the winner
 * to stylesheet order, which is undefined from the caller's point of view.
 * `twMerge` resolves the conflict by keeping the last, so a caller's
 * `className` can override a variant's default without `!important`.
 *
 * FOR THE shadcn PRIMITIVES IN THIS DIRECTORY ONLY. Feature components style
 * themselves with CSS Modules and must keep using `shared/lib/cn`, which is
 * plain `clsx`: running module-hashed class names through twMerge's trie on
 * every render costs measurable time in the dense grids (AttendanceMatrix,
 * the workflow board) and can never merge anything, because a hashed class is
 * not a utility.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
